import { RJSFSchema } from '@rjsf/utils';

export const PrimerConfigSchema: RJSFSchema = {
    type: "object",
    properties: {
        token: { type: 'string' },
        url: {type: 'string'},
        'Legacy-Workflows': {type: 'string'},
    }
  }